import urTooltip from "./urTooltip.js";
export default {
    install(Vue) {
        Vue.directive(urTooltip.name, urTooltip);
    }
};
